import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "@mui/material";
import React from "react";
import { VisibilityIndicatorIcon } from "./VisibilityIndicatorIcon.js";
export const VisibilityButton = React.forwardRef(({ isVisible, color = "secondary", ariaLabel, disabled = false, style, onChange, fontSize, ...props }, forwardedRef) => {
    return (_jsx(IconButton, { ref: forwardedRef, size: "small", color: color, "aria-label": ariaLabel, disabled: disabled, style: style, onClick: e => {
            e.stopPropagation();
            onChange(!isVisible);
        }, ...props, children: _jsx(VisibilityIndicatorIcon, { isVisible: isVisible, fontSize: fontSize, padding: 0, color: disabled ? undefined : color }) }));
});
//# sourceMappingURL=VisibilityButton.js.map